module.exports = __webpack_public_path__ + "img/SEJ_Eventos_eliminar_formulario.a0c98406.svg";